import React, { createContext, useContext, useCallback } from 'react';

const RentalContext = createContext();

export const RentalProvider = ({ children }) => {
  const isToolAvailable = useCallback((tool) => {
    return tool.available && !tool.maintenance;
  }, []);

  return (
    <RentalContext.Provider value={{ isToolAvailable }}>
      {children}
    </RentalContext.Provider>
  );
};

export const useRental = () => {
  const context = useContext(RentalContext);
  if (!context) {
    throw new Error('useRental must be used within a RentalProvider');
  }
  return context;
};
